import type { DataForCreateBaremetal } from '@/entities/baremetal';
import request from '@/shared/api/request';

export const getDataForCreateBaremetal = (): Promise<DataForCreateBaremetal> =>
  request({
    url: '/baremetals/data_for_create/',
  });
